module.exports = __webpack_public_path__ + "img/drawLucky.c9fd01c6.png";